"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceViewDocumentDropdown = class UcInvoiceViewDocumentDropdown extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    icons;
    ux;
    dataMembers = ['icons', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                icons: {
                    printerOn: "icon-park-outline:printer-one",
                    printerOff: "icon-park-outline:doc-fail",
                },
                ux: null,
            },
        };
    }
    get isVisible() {
        if (this.loaded) {
            return this.invoice.meta && (this.invoice.meta.has_print_document ||
                this.invoice.meta.invoice_view_upload_enabled ||
                this.invoice.meta.invoice_view_delete_enabled);
        }
        return null;
    }
    get noSplit() {
        if (this.loaded) {
            return this.invoice.meta &&
                !this.invoice.meta.invoice_view_upload_enabled &&
                !this.invoice.meta.invoice_view_delete_enabled;
        }
        return null;
    }
    get printerIcon() {
        if (this.loaded) {
            return this.invoice.meta && this.invoice.meta.has_print_document ? this.icons.printerOn : this.icons.printerOff;
        }
        return null;
    }
    async act_6804155476809633_script_7366_getActionArgs_value($event) {
        this.$fn.showFileInNewTab(this.invoice.links.print_url);
    }
    async act_6804155476809633_script_7366_getActionArgs($event) {
        return {
            value: () => this.act_6804155476809633_script_7366_getActionArgs_value($event),
        };
    }
    async evh_6804155476809633_click(event, scope) {
        return await this.actions.evh_6804155476809633_click.executeFromDOM(this, event, scope);
    }
    async act_5974459770896956_showModal_7368_getActionArgs($event) {
        return {
            name: "FileSelector",
            props: {
                url: this.invoice.links.print_url,
                accept: this.invoice.meta.accepted_print_document_formats,
            },
        };
    }
    async evh_5974459770896956_clickPreventStop(event, scope) {
        return await this.actions.evh_5974459770896956_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8852205820859826_rest_7370_getActionArgs($event) {
        return {
            method: "delete",
            container: this.container,
            resource: this.invoice,
        };
    }
    async act_8852205820859826_rest_7370_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_8852205820859826_clickPreventStop(event, scope) {
        return await this.actions.evh_8852205820859826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_6804155476809633_script_7366 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6804155476809633_script_7366_getActionArgs,
            displayName: "openDocument",
            events: [],
        });
        const evh_6804155476809633_click_7365 = new core_1.actions.EventHandlerImpl({
            action: act_6804155476809633_script_7366,
            event: "click",
            displayName: "openDocument",
        });
        const evh_6804155476809633_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6804155476809633_click_7365],
        });
        const act_5974459770896956_showModal_7368 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5974459770896956_showModal_7368_getActionArgs,
            events: [],
        });
        const evh_5974459770896956_clickPreventStop_7367 = new core_1.actions.EventHandlerImpl({
            action: act_5974459770896956_showModal_7368,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_5974459770896956_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5974459770896956_clickPreventStop_7367],
        });
        const act_8852205820859826_rest_7370 = new core_1.actions.RestAction({
            actionArgs: this.act_8852205820859826_rest_7370_getActionArgs,
            confirm: this.act_8852205820859826_rest_7370_getConfirm,
            events: [],
        });
        const evh_8852205820859826_clickPreventStop_7369 = new core_1.actions.EventHandlerImpl({
            action: act_8852205820859826_rest_7370,
            event: "click.prevent.stop",
            displayName: "rest",
        });
        const evh_8852205820859826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8852205820859826_clickPreventStop_7369],
        });
        return {
            act_6804155476809633_script_7366,
            evh_6804155476809633_click_7365,
            evh_6804155476809633_click,
            act_5974459770896956_showModal_7368,
            evh_5974459770896956_clickPreventStop_7367,
            evh_5974459770896956_clickPreventStop,
            act_8852205820859826_rest_7370,
            evh_8852205820859826_clickPreventStop_7369,
            evh_8852205820859826_clickPreventStop,
            openDocument: act_6804155476809633_script_7366,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceViewDocumentDropdown.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceViewDocumentDropdown.prototype, "onInvoice", null);
UcInvoiceViewDocumentDropdown = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceViewDocumentDropdown);
exports.default = UcInvoiceViewDocumentDropdown;
vue_property_decorator_1.Vue.component("UcInvoiceViewDocumentDropdown", UcInvoiceViewDocumentDropdown);
